import getConfig from "next/config";

import getPriceAlgorithm from "@shared/PriceAlgorithm/getPriceAlgorithm";

const { publicRuntimeConfig } = getConfig();
const { COUNTRY } = publicRuntimeConfig;

export const priceAlgorithm = getPriceAlgorithm(COUNTRY);
